import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from '../../../../../../shared/components/icon/icon.component';
import { SearchGeocoderService } from '../../../../../../shared/services/search-geocoder.service';

@Component({
  selector: 'app-chart-warning',
  templateUrl: './chart-warning.component.html',
  imports: [NgIf, IconComponent],
  styleUrls: ['./chart-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartWarningComponent {
  private searchGeocoder = inject(SearchGeocoderService);

  @Input() isToggleActive: boolean = false;
  /**
   * The group is still fetching. Every message here describes what the cell
   * holds, and none of them can be answered until it has arrived.
   */
  @Input() isLoading: boolean = false;
  @Input() selected: boolean = false;
  @Input() containsInfo: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() customText: string = '';
  @Input() selectedYear!: number | undefined;
  @Input() noAccessibleYears!: boolean;

  searchAddress(): void {
    this.searchGeocoder.requestSearch();
  }
}
